import React from "react";
import { Col, Row } from "react-bootstrap";
import { BlurredLine } from "../../atoms";

export default function DemonTile({ title, nested = false, children }) {
    return (
        <Row className={`bg-body rounded shadow-sm ${nested ? "my-3 m-3 mt-5" : "mb-md-5"}`}>
            <Col className={`p-3 ${nested ? "p-md-3" : "p-md-5"} `}>
                <h5>{title}</h5>
                <BlurredLine />
                {children}
            </Col>
        </Row>
    );
}
